import './global.js'
import Parse from 'parse';
import React from 'react';
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";

class ExploreChallengeDetail extends React.Component {
    render() {    
        return (
            <section className='post_list'> 
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                        <main className='listing explr-list '>
                            <div className='explr_list_hreo'>
                                <div className='listing-box'>
                                    <div className='bg-img'>
                                        <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                    </div>                                
                                    <div className='detail'>
                                        <h1>Soup for the Soul</h1>
                                        <h2>$1,000 in prizes</h2>
                                        <h3>Sponsored by joelskitchen</h3>
                                    </div>
                                </div>
                                <div className='explr_cotent'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sin <a href='#' title='#soup'>#soup</a></p>
                                    <div className="join_challange ">
                                        <div className='cta_btn btn-wrp'>
                                            <a href='/create-challenge' title='Join Challenge'>Join Challenge</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='explr_list_grid'>
                                <div class="gridPostRow">
                                    <div class="gridPost">
                                        <a href="/post/pasdunb4ED">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg"/>
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>      
        );
    }
}

export default ExploreChallengeDetail;


// WEBPACK FOOTER //
// ./src/ExploreChallengeDetail.jsx